module.exports = __webpack_public_path__ + "img/jorge-gleizer.3b3806da.jpg";